// extracted by mini-css-extract-plugin
module.exports =  {"root":"fDM29At6rBnoz3v2Qayl","label":"hx6F7g0NNILdLrsifYob","description":"KMQDNbDlBDMEFkFGTF7T"};